exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".introduction{\r\n    margin-top: 20px;\r\n}\r\n.image-action img{\r\n    margin-bottom: 20px;\r\n    width: 100% !important;\r\n}\r\n@media only screen and (max-width: 760px) {\r\n    .image-action{\r\n        margin-bottom: 20px;\r\n        width: 100% !important;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/invite-banners/invite-banners.component.css
// module id = ../../../../../src/app/invite-banners/invite-banners.component.css
// module chunks = main